import React from "react"
import tw, { css, styled } from "twin.macro"
import { Typography } from "../components/Typography"
import { Layout } from "../components/Layout"
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons"
import { IconButton } from "../components/IconButton"
import { Separator } from "../components/Separator"
import { CSSTransition } from "react-transition-group"
import { Heading } from "../components/Heading"

export default function Me() {
  const [expandedItem, setExpandedItem] = React.useState<number | undefined>()

  const items = [
    {
      year: "1993",
      title: "Spawn",
      detail:
        "More Information about the thing that I have done can be found and entered in this spot",
    },
    {
      year: "1993",
      title: "Spawn",
      detail:
        "More Information about the thing that I have done can be found and entered in this spot",
    },
    {
      year: "1993",
      title: "Spawn",
      detail:
        "More Information about the thing that I have done can be found and entered in this spot",
    },
    {
      year: "1993",
      title: "Spawn",
      detail:
        "More Information about the thing that I have done can be found and entered in this spot",
    },
    {
      year: "1993",
      title: "Spawn",
      detail:
        "More Information about the thing that I have done can be found and entered in this spot",
    },
  ]

  const handleToggleExpanded = (itemIndex: number) => {
    if (expandedItem === itemIndex) {
      setExpandedItem(undefined)
    } else {
      setExpandedItem(itemIndex)
    }
  }

  return (
    <Layout>
      <Heading title="ME" />
      <Typography variant="h2" tw="mb-1">
        Patrick Simmelbauer
      </Typography>
      <Typography variant="h3" tw="mb-8">
        Front-End Developer
      </Typography>
      <div>
        <div
          css={[
            css`
              ${tw`bg-gray-light absolute h-full z-0`} left: 4.3125rem;
              width: 2px;
              height: 400px;
            `,
          ]}
        />
        {items.map((item, index) => (
          <Row
            key={index}
            {...item}
            expanded={expandedItem === index}
            toggleExpanded={() => handleToggleExpanded(index)}
          />
        ))}
      </div>
    </Layout>
  )
}

const Row = ({
  year,
  title,
  detail,
  expanded = false,
  toggleExpanded,
}: {
  year: string
  title: string
  detail: string
  expanded?: boolean
  toggleExpanded: () => void
}) => {
  const ExpandButton = styled(IconButton)``

  const Content = styled.div`
    ${tw`col-start-3 col-end-5`} max-height: 0;
    overflow: hidden;
  `

  const Container = styled.div`
    ${tw`grid grid-cols-timeline justify-start gap-x-2 -mb-separator cursor-pointer`}

    &:hover ${ExpandButton} {
      ${tw`bg-button-hover`}
    }

    &:active ${ExpandButton} {
      ${tw`bg-button-active `}
    }

    &.expanded-enter {
      ${Content} {
        transition: all 0.25s ease-in;
        max-height: 0;
      }
    }

    &.expanded-enter-active {
      ${Content} {
        max-height: 10rem;
      }
    }

    &.expanded-enter-done {
      ${Content} {
        max-height: 10rem;
      }
    }

    &.expanded-exit {
      ${Content} {
        transition: max-height 0.1s ease-out;
        max-height: 10rem;
      }
    }

    &.expanded-exit-active {
      ${Content} {
        max-height: 0;
      }
    }

    &.expanded-exit-done {
      ${Content} {
        max-height: 0;
      }
    }
  `

  return (
    <CSSTransition in={expanded} timeout={300} classNames="expanded">
      <Container onClick={toggleExpanded}>
        <Separator tw="col-start-3 col-end-5" />
        <Typography
          variant="body"
          renderAs="span"
          tw="text-primary w-7 text-center self-center"
        >
          {year}
        </Typography>

        <div
          css={[
            tw`z-10 self-center rounded-full w-5 h-5 bg-gray-light box-border border-2`,
            expanded ? tw`border-primary-dark` : tw`border-gray-dark`,
          ]}
        />

        <Typography variant="body" renderAs="span" tw="self-center">
          {title}
        </Typography>

        <div tw="self-center justify-end">
          <ExpandButton icon={expanded ? faAngleUp : faAngleDown} tw="my-1" />
        </div>

        <Content>
          <Typography tw="mb-4" variant="body">
            {detail}
          </Typography>
        </Content>

        <Separator tw="col-start-3 col-end-5" />
      </Container>
    </CSSTransition>
  )
}
